import { useEffect, useState } from "react";

/**
 * Cycles through phrases with a synchronized fade + slide-up animation.
 * - Out animation: opacity 0, translateY +12px
 * - In animation: opacity 100, translateY 0
 */
export default function RotatingText({
  phrases,
  intervalMs = 2000,
  transitionMs = 350,
  className = "",
  "data-testid": testId,
}) {
  const [index, setIndex] = useState(0);
  const [show, setShow] = useState(true);

  useEffect(() => {
    if (!phrases || phrases.length <= 1) return undefined;
    let inSwap = false;
    const tick = setInterval(() => {
      if (inSwap) return;
      inSwap = true;
      setShow(false);
      window.setTimeout(() => {
        setIndex((prev) => (prev + 1) % phrases.length);
        setShow(true);
        inSwap = false;
      }, transitionMs);
    }, intervalMs);
    return () => clearInterval(tick);
  }, [phrases, intervalMs, transitionMs]);

  if (!phrases || phrases.length === 0) return null;

  return (
    <span
      data-testid={testId}
      aria-live="polite"
      className={`inline-block ${className}`}
      style={{
        transition: `opacity ${transitionMs}ms ease-out, transform ${transitionMs}ms ease-out`,
        opacity: show ? 1 : 0,
        transform: show ? "translateY(0)" : "translateY(12px)",
        willChange: "opacity, transform",
      }}
    >
      {phrases[index]}
    </span>
  );
}
